import { useTranslation } from 'react-i18next';
import { ImagePlus } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { cn } from '@/lib/utils';

type Props = {
  className?: string;
  isInvalid: boolean;
  onClick: () => void;
};

export const ImageTilePicker = (props: Props) => {
  const { className, isInvalid, onClick } = props;
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className={cn('text-muted-foreground size-20 border-dashed', className)}
      aria-label={t('Choose File')}
      aria-invalid={isInvalid}
      onClick={onClick}
    >
      <ImagePlus className="size-6" />
    </Button>
  );
};
